const initialState = {
    error: [],
    users: {},
    success: false,
    message: ""
}
const changePassword = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGEPASSWORD':
            return {
                ...state,
                response: action.response
            }
        default:
            return state;
    }
};
export default changePassword;



// WEBPACK FOOTER //
// ./src/reducers/changePassword.js